import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginToken } from '../model/login-token.model';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthLoginService {

  private readonly TOKEN_URL = environment.pathLoginToken;

  constructor(private http: HttpClient) {
    console.log('AuthLoginService initialized', this.TOKEN_URL);
  }


  fetchToken(email:string, password:string): Observable<LoginToken> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.http.post<LoginToken>(this.TOKEN_URL, {
      "email": email,
      "password": password
    }, { headers });
  }

  decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (e) {
      return null
    }
  }

}
